<template>
  <v-menu
    v-model="isOpen"
    bottom
    left
    :close-on-content-click="false"
    offset-y
    max-height="300"
    nudge-right="5"
    nudge-bottom="5"
    :min-width="chipGroupMaxWidth"
  >
    <template v-slot:activator="{ on: menu, attrs }">
      <v-btn
        style="margin-top: 3px; margin-left: 6px"
        dark
        x-small
        icon
        v-bind="attrs"
        v-on="{ ...menu }"
      >
        <v-icon size="22" v-if="isOpen">mdi-menu-down</v-icon>
        <v-icon size="22" v-else>mdi-menu-up</v-icon>
      </v-btn>
    </template>
    <v-list dense>
      <v-list-item>
        <v-list-item-action class="mr-2">
          <v-checkbox
            dense
            :indeterminate="someNodesSelected"
            :input-value="allNodesSelected"
            @click.stop="toggleCompleteSelection"
          />
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Select all</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
      <v-list-item-group
        v-model="selectedMeetingTypes"
        multiple
        active-class=""
      >
        <v-list-item
          v-for="(item, index) in meetingTypesList"
          :key="index"
          :value="item"
        >
          <template v-slot:default="{ active }">
            <v-list-item-action class="mr-2">
              <v-checkbox dense :input-value="active"></v-checkbox>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                <v-chip :color="item.color" :dark="isDarkTheme(item.color)" label small>
                  {{ item.label }}
                </v-chip>
              </v-list-item-title>
            </v-list-item-content>
          </template>
        </v-list-item>
      </v-list-item-group>
    </v-list>
    <!-- <v-list dense>
      <v-list-item-group
        v-model="selectedMeetingTypes"
        multiple
        active-class=""
      >
        <v-list-item
          v-for="(item, index) in meetingTypesList"
          :key="index"
          :value="item"
        >
          <template v-slot:default="{ active }">
            <v-list-item-action class="mr-2">
              <v-checkbox dense :input-value="active"></v-checkbox>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                <v-chip :color="item.color" label small>
                  {{ item.label }}
                </v-chip>
              </v-list-item-title>
            </v-list-item-content>
          </template>
        </v-list-item>
      </v-list-item-group>
    </v-list> -->
  </v-menu>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import MeetingTypeChipGroup from "./MeetingTypeChipGroup.vue";
import customFunctions from "@/codeFiles/taskHelper.js";
export default {
  components: { MeetingTypeChipGroup },
  name: "MeetingTypeMenuList",
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    open: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // isOpen: true,
    };
  },
  computed: {
    ...mapState({
      meetingTypeFilterWidth: (state) => state.agenda.meetingTypeFilterWidth,
    }),
    noNodesSelected() {
      return this.selectedMeetingTypes.length === 0;
    },
    someNodesSelected() {
      return this.selectedMeetingTypes.length > 0 && !this.allNodesSelected;
    },
    allNodesSelected() {
      return this.selectedMeetingTypes.length === this.meetingTypesList.length;
    },
    chipGroupMaxWidth() {
      return this.meetingTypeFilterWidth - 22;
    },
    ...gettersMap(),
    selectedMeetingTypes: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value || []);
      },
    },
    isOpen: {
      get() {
        return this.open;
      },
      set(value) {
        this.$emit("update:open", value || false);
      },
    },
  
  },
  methods: {

      isDarkTheme(color){
      return customFunctions.getContrast(color);
    },
    toggleCompleteSelection() {
      if (this.noNodesSelected || this.someNodesSelected) {
        this.selectedMeetingTypes = this.meetingTypesList.map((node) => node);
      } else {
        this.selectedMeetingTypes = [];
      }
    },
  },
};

function gettersMap() {
  return mapGetters({
    meetingTypesList: "tenant/agendaMeetingTypes",
  });
}
</script>

<style>
</style>